<div
  class="p-2 w-full rounded-lg cursor-pointer border border-smoke hover:border-smoke-darker transition-colors duration-200 container"
  [ngClass]="{
    'bg-grape-lighter': emphasize
  }">
  <div class="flex gap-2 justify-between items-center">
    <div class="flex flex-col gap-1">
      <div class="flex flex-row gap-4">
        <div class="strong">{{ headline }}</div>
        <sbnb-badge *ngIf="new" [context]="'exuberant'" volume="high">NEW</sbnb-badge>
        <sbnb-badge *ngIf="on" [context]="'positive'" volume="high">ON</sbnb-badge>
      </div>
      <div *ngIf="subline" class="text-xs text-night" [ngClass]="{ 'text-grape': emphasize }">{{ subline }}</div>
    </div>
    <sbnb-icon [icon]="'chevron-right'" [size]="20" class="arrow" [ngClass]="{ 'text-grape': emphasize }"></sbnb-icon>
  </div>
</div>
